import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, ButtonVariant, PageContainer } from '@edikk-edikk/country-layout-black';
import { RouterConfig, useIsFrontendStyleDefault } from '@edikk-edikk/country-frontend';
import { useHomeContext } from '#home/hooks';
import { AdvertCardList } from '#advert/components/card-list';
import homeAdvertListCss from '../../asssets/home-advert-list.module.scss';

const AdvertList: FC = () => {
  const { mainCity, advertList } = useHomeContext();
  const isFrontendStyleDefault = useIsFrontendStyleDefault();

  if (!advertList || advertList.length === 0) {
    return null;
  }

  return (
    <PageContainer>
      <div className={homeAdvertListCss.homeAdvertList}>
        <div className={homeAdvertListCss.homeAdvertList__cardListContainer}>
          <AdvertCardList adverts={advertList} max6 />
        </div>
        <div className={homeAdvertListCss.homeAdvertList__loadMoreContainer}>
          <Button
            variant={isFrontendStyleDefault ? ButtonVariant.white : ButtonVariant.richMaroon}
            textUppercase
            pill
            paddingX5
            navLinkProps={{
              to: mainCity.url,
              state: { routerConfig: RouterConfig.initForCity(mainCity.id) },
            }}
          >
            <FormattedMessage defaultMessage="See all models in {city}" values={{ city: mainCity.title }} />
          </Button>
        </div>
      </div>
    </PageContainer>
  );
};

export { AdvertList };
